<template>
  <!-- Time Source -->
  <v-select 
    ref         = "timecode_selector"
    class       = "timecode-select mt-0"
    v-model     = "displaySource"
    dense
    solo
    hide-details
    :items      = "timeSources"
    item-text   = "name"
  >
  </v-select>
</template>

<script>
import { SELECT_TIME_DISPLAY_SOURCE } from '@/utils/action-types';
import { mapState } from 'vuex';
import { SecondsToShortTime } from '@/utils/timeline-utilities';
import { storeSelectedTimeDisplaySource } from "@/store/utilities/persistence.utils";

// #region Constants

const SECONDS_DISPLAY_TYPE  = 'seconds';
const SECONDS_DISPLAY_KEY   = '__seconds__';
const TIMECODE_DISPLAY_TYPE = 'timecode';

const FRAMES_DISPLAY_TYPE   = 'frames';
const FRAMES_DISPLAY_KEY    = '__frames__';

// #endregion Constants

export default {
  name: 'Timecode',
  data: function () {
    return {
      pollHandle: null,
      timecodes:  [],
    };
  },
  computed: {
    ...mapState(['videoCurrentTime', 'videoDuration', 'videoElement', 'timeDisplaySource']),
    time() {
      return SecondsToShortTime(this.videoCurrentTime);
    },
    timecodeSources() {
      return this.$store.state.video.timecodeSources;
    },
    timeSources() {
      if (this.timecodeSources) {
        let sources = this.timecodeSources.map((timecode) => {
          return {
            name:  timecode,
            value: timecode,
            type:  TIMECODE_DISPLAY_TYPE,
          };
        });

        sources.push({
          divider: true,
        });

        sources.push({
          name:  'Time',
          value: SECONDS_DISPLAY_KEY,
          type:  SECONDS_DISPLAY_TYPE,
        });

        sources.push({
          name:  'Frames',
          value: FRAMES_DISPLAY_KEY,
          type:  FRAMES_DISPLAY_TYPE
        }); 

        return sources;
      }
      return undefined;
    },
    displaySource: {
      get() {
        return this.timeDisplaySource ? this.timeDisplaySource.value : SECONDS_DISPLAY_KEY;
      },
      set(source) {
        let timeSource = this.timeSources.find((other) => other.value === source);
        this.$store.dispatch(SELECT_TIME_DISPLAY_SOURCE, timeSource);
        storeSelectedTimeDisplaySource(JSON.stringify(timeSource));
        this.$refs.timecode_selector.blur();
      },
    },
  },
  methods: {},
};
</script>

<style scoped>

.timecode-select {
  max-width: 225px;
}
</style>
